import { Modal } from 'components/Modal';
import { ModalBody } from 'components/Modal/ModalBody';
import { ModalActions } from 'components/Modal/ModalActions';
import { Button } from 'components/Button';
import noop from 'lodash/noop';
import { RadioGroup } from '@headlessui/react';
import { CheckboxButton } from 'components/CheckboxButton';
import isBoolean from 'lodash/isBoolean';
import { HiringUpdateFlowContext } from 'features/EmployerHiringUpdateFlow/EmployerHiringUpdateContext';
import { useContext } from 'react';
import { HiringUpdateFlowSteps } from 'features/EmployerHiringUpdateFlow/EmployerHiringUpdateFlow.constants';

export const HaveYouHiredStep = () => {
  const { open, step, goToNextStep, hiredSomeone, setHiredSomeone } =
    useContext(HiringUpdateFlowContext);

  return (
    <Modal
      panelProps={{
        className: 'sm:!max-w-[314px]',
      }}
      open={open && step === HiringUpdateFlowSteps.HIRED_SOMEONE_LATELY}
      heading={
        <span className="text-primary-pure-blue">
          Have you hired someone in the last 30 days? 💼
        </span>
      }
      actionRequired
      onClose={noop}
    >
      <ModalBody>
        <RadioGroup
          className="mt-6 flex flex-col gap-4"
          onChange={setHiredSomeone}
          value={hiredSomeone}
        >
          <RadioGroup.Option value={true}>
            {({ checked }) => (
              <CheckboxButton className="!px-4" singleSelection checked={checked}>
                <div className="ml-2 flex items-center gap-4">
                  <span>👍</span>
                  <span className="text-sm font-normal text-neutral-dark whitespace-normal">
                    Yes, I&apos;ve hired someone
                  </span>
                </div>
              </CheckboxButton>
            )}
          </RadioGroup.Option>

          <RadioGroup.Option value={false}>
            {({ checked }) => (
              <CheckboxButton className="!px-4" singleSelection checked={checked}>
                <div className="ml-2 flex items-center gap-4">
                  <span>⛔</span>
                  <span className="text-sm font-normal text-neutral-dark whitespace-normal">
                    No, I haven&apos;t hired
                  </span>
                </div>
              </CheckboxButton>
            )}
          </RadioGroup.Option>
        </RadioGroup>
      </ModalBody>

      <ModalActions>
        <Button
          type="button"
          size="lg"
          fullWidth
          onClick={goToNextStep}
          disabled={!isBoolean(hiredSomeone)}
        >
          Confirm
        </Button>
      </ModalActions>
    </Modal>
  );
};
